// extracted by mini-css-extract-plugin
export default {"chart":"TopDevice_chart__jKltw","legend":"TopDevice_legend__ML4tD","title":"TopDevice_title__67PdP","percent":"TopDevice_percent__Jgf3s"};